export default {
  alpinum: {
    customSections: {
      useCases: {
        title: "Casi d'uso",
        absoluteReturnPortfolio: {
          disclaimer:
            "Questo è un documento pubblicitario. Questo documento non costituisce un'offerta a chiunque, o una sollecitazione da parte di chiunque, a effettuare investimenti in titoli. Questo documento è destinato esclusivamente al destinatario previsto e non può essere trasmesso o distribuito a terzi. Le performance passate non sono una guida per le performance future e potrebbero non ripetersi. Si ricorda che il valore degli investimenti può scendere così come salire e non è garantito. Questi dati di performance non tengono conto delle commissioni e dei costi sostenuti per l'emissione e il riscatto delle quote. Il fondo rinuncia a un confronto con un benchmark. Per ulteriori informazioni relative ai rischi, si prega di fare riferimento alla sezione corrispondente del prospetto del fondo (come modificato di volta in volta). Nulla di quanto contenuto in questo documento costituisce consulenza finanziaria, legale, fiscale, di investimento o di altro tipo, né alcuna decisione di investimento o di altro tipo dovrebbe essere presa esclusivamente sulla base di questo documento. Qualsiasi decisione di investimento dovrebbe basarsi sul prospetto del fondo (incl. contratto del Fondo integrato), sulla relazione annuale e sui moduli di sottoscrizione ecc. Sebbene le informazioni contenute in questo documento siano state ottenute da fonti ritenute affidabili, non viene fatta alcuna dichiarazione in merito alla loro accuratezza o completezza, e non si dovrebbe fare affidamento su di esse come tali. Questo documento non deve essere emesso, fatto circolare o distribuito se non a “investitori qualificati” come definito nella CISA. Per qualsiasi richiesta riguardante il documento contattare Alpinum Investment Management AG per ulteriori informazioni. Il documento non è diretto e non può essere fornito a nessuna persona in qualsiasi giurisdizione a cui sia vietato per legge accedere a tali informazioni. Questo documento e le informazioni in esso contenute sono indirizzati esclusivamente a “investitori qualificati”, che non sono “US persons” come definito nel Regulation S del US Securities Act del 1933. Né questo documento, né copie dello stesso possono essere inviati o portati negli Stati Uniti d'America né consegnati a una US person. L'agente pagatore del fondo è UBS Switzerland AG, Bahnhofstrasse 45, CH-8001 Zurigo. Il prospetto del fondo così come le relazioni annuali del fondo sono disponibili gratuitamente solo per investitori qualificati presso Alpinum Investment Management AG, Talstrasse 82, CH-8001 Zurigo, Svizzera.",
          strategyName: "Alpinum Absolute Return",
          customStrategyName: "Custom Alpinum Absolute Return",
          title: "Alpinum",
          total: "Totale",
          assetClasses: {
            liquidity: "Liquidità",
            fixedIncomeLongOnly: "Reddito Fisso Long-Only",
            equityLongOnly: "Azionario Long-Only",
            equityLongShort: "Azionario Long-Short",
            alternativesOpportunistics: "Alternativi - Opportunistici",
            realAssets: "Beni Reali (Real Assets)",
          },
          description: {
            interaction:
              "Questa è una pagina dove puoi esplorare interattivamente varie versioni del Portafoglio Alpinum Absolute Return.",
            firstBullet:
              "Il portafoglio è adatto a investitori con una tolleranza relativamente bassa al rischio e alle fluttuazioni di mercato.",
            secondBullet:
              "Il portafoglio si concentra sulla preservazione del capitale offrendo comunque un moderato apprezzamento del capitale nel tempo.",
            thirdBullet:
              "Il portafoglio segue una strategia di rendimento obiettivo (target return) mirando a raggiungere un rendimento annualizzato nell'intervallo di circa 5,5 - 7,5% su un ciclo economico.",
          },
          historicalResults: {
            title: "Risultati storici",
            biggestDrawdowns: {
              title: (ctx) => `Maggiori drawdown mensili di ${ctx.named("benchmark")}`,
            },
            compositionPortfolio: {
              title: "Composizione portafoglio",
            },
            drawdowns: {
              title: "Drawdown mensili",
            },
            historicalPerformance: {
              title: "Performance storica",
            },
            performanceTable: {
              title: "Tabella performance",
              statistics: {
                annualizedVolatility: "Deviazione standard annualizzata",
                maximumDrawdown: "Drawdown massimo",
                ratioOfNegativeMonthlyReturns: "Percentuale di mesi negativi",
                ratioOfPositiveMonthlyReturns: "Percentuale di mesi positivi",
              },
            },
            portfolioPerformanceOverview: {
              title: "Panoramica",
            },
            totalReturn: {
              title: "Rendimento totale",
            },
            yearlyReturns: {
              title: "Rendimenti annuali",
            },
          },
          metaInfo: {
            title: "Portafoglio Absolute Return",
          },
          overview: {
            lastMonth: "Ultimo mese",
            lastYear: (ctx) => `Ultimo anno (${ctx.named("lastYear")})`,
            ytd: (ctx) => `YTD ${ctx.named("year")}`,
          },
          parameters: {
            runAnalysis: "Esegui analisi",
            runUseCase: "Esegui caso d'uso",
            benchmark: "Benchmark",
            title: "Composizione Absolute Return",
          },
        },
      },
    },
  },
  bcf: {
    redirectButtonNavBarText: "Torna alla Home",
  },
  bonhote: {
    redirectButtonNavBarText: "Torna alla Home",
  },
  calmgard: {
    nextSubscriptionAndRedemption: {
      nextRedemption: (ctx) =>
        `Il <b>Rimborso</b> che avviene prima del ${ctx.named(
          "date"
        )} alle 12:00 CET sarà eseguito all'ultimo NAV di ${ctx.named("month")}.`,
      nextSubscription: (ctx) =>
        `La <b>Sottoscrizione</b> che avviene prima del ${ctx.named(
          "date"
        )} alle 12:00 CET sarà eseguita all'ultimo NAV di ${ctx.named("month")}.`,
      title: "Prossime date di negoziazione possibili",
    },
  },
  citeGestion: {
    categories: {
      assetAllocationProducts: "Prodotti di Asset Allocation",
      etfPortfolios: "Portafogli Modello ETF",
      fundPortfolios: "Portafogli Modello Fondi",
    },
  },
  cronos: {
    redirectButtonNavBarText: "Home page Cronos",
  },
  demo: {
    customSections: {
      useCases: {
        title: "Casi d'uso",
        alpinum: {
          strategyName: "Alpinum",
          title: "Alpinum",
          historicalResults: {
            title: "Risultati storici",
            biggestDrawdowns: {
              title: (ctx) => `Maggiori drawdown di ${ctx.named("benchmark")}`,
            },
            drawdowns: {
              title: "Drawdown",
            },
          },
          metaInfo: {
            title: "Caso d'uso - Alpinum",
          },
          parameters: {
            runButton: "Esegui caso d'uso",
            benchmark: "Benchmark",
            title: "Parametri",
          },
        },
      },
    },
  },
  mirante: {
    redirectButtonNavBarText: "Home page MFM",
  },
  msm: {
    slgOpportunitiesFund: {
      useCase: {
        strategyName: "Allocazione personalizzata con SLG",
        historicalResults: {
          title: "Risultati storici",
          biggestDrawdowns: {
            title: (ctx) => `Maggiori drawdown di ${ctx.named("benchmark")}`,
          },
          drawdowns: {
            title: "Drawdown",
          },
        },
        metaInfo: {
          title: "Caso d'uso - SLG Opportunities Fund",
        },
        notify: {
          customPortfolioUpdateErrorText:
            "L'aggiornamento del portafoglio personalizzato è fallito.",
          customPortfolioUpdateSuccessText:
            "Il portafoglio personalizzato è stato aggiornato con successo.",
        },
        parameters: {
          runButton: "Esegui caso d'uso",
          benchmark: "Benchmark",
          title: "Parametri",
          customPortfolio: {
            hideForNonAdminsText: "Nascondi per non-admin",
            title: "Portafoglio personalizzato",
            updateButton: "Aggiorna portafoglio personalizzato",
            uploadCsvText: "Carica CSV per aggiornare i dati",
            uploadCsvTooltip:
              "Il CSV deve avere 1 riga di intestazione e 2 colonne, la prima con le date nel formato AAAA-MM-GG, e la seconda con i prezzi.",
          },
        },
      },
    },
  },
  uti: {
    categories: {
      quantitativeStrategies: "Strategie Quantitative ÄPI®",
      thematicStrategies: "Strategie Tematiche NEÜ®",
    },
  },
};
